<template>
  <div class="page-users">
    <sk-page-header v-if="app_id" :header="app_name" :subheader="app_id">
      <div slot="right">
        <!-- <sk-button sk-mode="hollow" icon="airplay">sk-mode='hollow'</sk-button> -->
        <sk-button
          sk-mode="hollow"
          icon="help-circle"
          icon-size="16"
          size="sm"
          weight="semi-bold"
          @click="onRequestHelp"
        >
          Request help
        </sk-button>
      </div>
    </sk-page-header>

    <sk-panel>
      <sk-panel-header
        slot="header"
        header="Recent users"
        text="Please use search to find a specific user"
      >
        <sk-textinput
          icon-prepend="user"
          icon-append="search"
          :initial-value="input"
          :show-loading="loading.filter"
          @changed="onInputChange"
          @iconAppendClick="onIconAppendClick"
          @enter="onIconAppendClick"
          class="search-text-input"
          placeholder="Enter exact user id"
          slot="actions"
        ></sk-textinput>
      </sk-panel-header>
      <sk-panel-body slot="body">
        <List :users="users" v-if="users.length" />
        <div v-else class="no-data">
          No data found
        </div>
      </sk-panel-body>
    </sk-panel>

    <spinner class="animated" v-if="loading.filter || loading.list"></spinner>
  </div>
</template>

<script>
import store from 'store';
import { mapState } from 'vuex';
import notifications from 'services/Notifications';
import { configs } from 'config';
import { Spinner } from 'components/loaders';
import i18n from 'services/i18n';

import List from './modules/List.vue';

export default {
  components: {
    Spinner,
    List,
  },

  async beforeRouteEnter(to, from, next) {
    try {
      store.commit('users/reset');
      await store.dispatch('users/get', { appId: to.params.appId });

      next();
    } catch (err) {
      notifications.add(i18n.t('users.errors.getting_init_data_failed'));
      console.log(err);
    }
  },

  computed: {
    ...mapState('users', ['users', 'app_id', 'app_name', 'input']),
    appId() {
      return this.$route.params.appId;
    },
  },

  data() {
    const c = configs();
    return {
      icons: {
        loading: c.IMAGES.LOADING,
      },
      loading: {
        filter: false,
        list: false,
      },
    };
  },

  methods: {
    async getUsers() {
      try {
        this.loading.list = true;

        await store.dispatch('users/get', {
          appId: this.appId,
        });
      } catch (err) {
        notifications.add(i18n.t('users.errors.getting_users_data_failed'));
        console.log(err);
      } finally {
        this.loading.list = false;
      }
    },

    onInputChange(event) {
      store.commit('users/input', event.detail);
    },

    async onIconAppendClick() {
      try {
        // If the search input is not empty filter by the search input, else load all users
        if (this.input) {
          this.loading.filter = true;

          await store.dispatch('users/filterById');
        } else {
          store.commit('users/update', []);

          await this.getUsers();
        }
      } catch (err) {
        notifications.add(i18n.t('users.errors.getting_user_data_failed'));
        console.log(err);
      } finally {
        this.loading.filter = false;
      }
    },

    onRequestHelp() {
      location.href = 'mailto:support@sentiance.com';
    },
  },
};
</script>
